import { Button, ButtonLoaderPlacement, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import React from 'react';

import { getTranslation, keys } from '../../../../../../../Resources/Translations';
import { ProductAvailabilityNotificationSuccess } from '../../ProductAvailabilityNotificationSuccess';
import { ProductAvailabilityNotificationStatus } from './ProductAvailabilityNotificationStatus';
import { ProductAvailabilityNotificationViewProps } from './ProductAvailabilityNotificationViewProps';

export const ProductAvailabilityNotificationPageView = (props: ProductAvailabilityNotificationViewProps) => (
    <div className="ProductAvailabilityNotificationPageView">
        {props.status === ProductAvailabilityNotificationStatus.Success && <ProductAvailabilityNotificationSuccess />}
        {props.status === ProductAvailabilityNotificationStatus.LimitExceeded && <ProductAvailabilityNotificationSuccess />}
        {props.status === ProductAvailabilityNotificationStatus.Input && (
            <>
                <span className="ProductAvailabilityNotificationPageView__Heading">{getTranslation(keys['product.availabilityNotification.heading'])}</span>
                <span className="ProductAvailabilityNotificationPageView__Subheading">
                    {getTranslation(keys['product.availabilityNotification.subheading'])}
                </span>

                {props.errorMessage && !props.isInputModalVisible && (
                    <span className="ProductAvailabilityNotificationPageView__ErrorMessage">{props.errorMessage}</span>
                )}

                <Button
                    variant={ButtonVariant.Tertiary}
                    size={ButtonSize.Large}
                    loading={props.isRequestActive}
                    onClick={props.handleOnClick}
                    className="ProductAvailabilityNotificationPageView__Button"
                    disabled={props.isButtonDisabled && !props.isInputModalVisible}
                    loaderPlacement={ButtonLoaderPlacement.Right}
                >
                    {getTranslation(keys['product.availabilityNotification.button'])}
                </Button>
            </>
        )}
    </div>
);
